import React from 'react';

import {StepViewFieldProps} from '../commonprops';

export const StepViewTextField = ({field}: StepViewFieldProps) => (
  <div className="form-group row mb-0">
    {field.label !== '' ? (
      <label
        htmlFor={`step-field-${field.id}`}
        className="col-12 col-form-label pt-0"
      >
        {field.label}
      </label>
    ) : null}
    <div className="col-12">
      <input
        id={`step-field-${field.id}`}
        disabled
        className="form-control"
        type="text"
      />
    </div>
  </div>
);
